<template>
  <div :class="rowClass" :style="rowStyle"><slot></slot></div>
</template>

<script>
import { oneOf } from '../../utils/assist'

const classPrefix = 'bcc-row'

export default {
  name: 'BccRow',
  props: {
    type: {
      type: String,
      validator (val) {
        return oneOf(val, ['flex'])
      }
    },
    gutter: {
      type: Number,
      default: 16
    },
    align: {
      type: String,
      validator (val) {
        return oneOf(val, ['top', 'middle', 'bottom'])
      }
    },
    justify: {
      type: String,
      validator (val) {
        return oneOf(val, ['start', 'end', 'center', 'space-around', 'space-between'])
      }
    }
  },
  data () {
    return {
      rowData: {
        gutter: this.gutter
      }
    }
  },
  provide () {
    return {
      rowData: this.rowData
    }
  },
  computed: {
    rowClass () {
      return [
        {
          [`${classPrefix}`]: !this.type,
          [`${classPrefix}-${this.type}`]: !!this.type,
          [`${classPrefix}-${this.type}-${this.align}`]: !!this.align,
          [`${classPrefix}-${this.type}-${this.justify}`]: !!this.justify
        }
      ]
    },
    rowStyle () {
      let style = {}
      if (this.gutter !== 0) {
        style = {
          marginLeft: `${this.gutter / -2}px`,
          marginRight: `${this.gutter / -2}px`
        }
      }
      return style
    }
  },
  watch: {
    gutter (val) {
      this.rowData.gutter = val
    }
  }
}
</script>
